module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section04_02_american-village-9dd2af4e375e46d19c02ea836e4a8203.jpg";